import React from "react";
import {
  Text,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import { verifyCode } from "../services/forgotPass";
import { GoBackButton } from "./GoBackButton";

export const AuthLogin = ({ setSignUpp, email, setResetToken }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!otp) return;
    setLoading(true);
    verifyCode({ email, otp }, setSignUpp, setLoading, setResetToken);
  };

  return (
    <Stack>
      <GoBackButton onClick={() => setSignUpp("forgot")} />
      <Text
        color={"primary.500"}
        fontSize="40px"
        fontWeight={"semibold"}
        mb={"-10px"}
      >
        Authentication Code
      </Text>
      <Text fontSize={"18px"} fontWeight={500}>
        Input the code sent to your email address
      </Text>
      <FormControl cursor={"pointer"} borderColor="#CFE5E2">
        <FormLabel
          htmlFor="auth-code"
          color={"#4D4A4A"}
          fontSize="18px"
          pt={"17px"}
        >
          Input Code
        </FormLabel>
        <Input
          id="auth-code"
          type="text"
          bg={"#F9FEFF"}
          mb="15px"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
      </FormControl>
      <Button
        bg={"primary.500"}
        size={"md"}
        color="#FFFFFF"
        w="100%"
        fontWeight={400}
        isLoading={loading}
        fontSize={"13px"}
        _hover={{ bg: "primary.600" }}
        onClick={() => handleSubmit()}
        //onClick={() => setSignUpp("authlogin")}
      >
        Continue
      </Button>
    </Stack>
  );
};
